/** 投放管理项目入口与投放设置；基础配置独立路由，历史任务不进入运行时导航。 */
import { useState } from 'react';
import './LandingManagement.css';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { PageTabs } from '~/ui/PageTabs';
import LandingProductsPage from './LandingProductsPage';
import LandingTemplatesPanel from './LandingTemplatesPanel';
import { LandingProjectDetail, parseProjectTab } from './projects/LandingProjectDetail';
import { LandingProjectsPanel } from './projects/LandingProjectsPanel';
export default function LandingPage({ settings = false }: { settings?: boolean }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { projectId } = useParams<{ projectId: string }>();
  const [searchParams, setSearchParams] = useSearchParams();
  const [baseTab, setBaseTab] = useState<'products' | 'templates'>('products');
  // 列表条件在列表 URL 的 query 里；进详情时随 history state 带上，返回列表时原样恢复。
  // 直接打开详情链接（无 state）时返回默认列表。
  const listSearch = projectId
    ? ((location.state as { listSearch?: string } | null)?.listSearch ?? '')
    : location.search;
  const open = (id: string) =>
    navigate(`/landing/projects/${encodeURIComponent(id)}`, { state: { listSearch } });
  if (projectId)
    return (
      <LandingProjectDetail
        key={projectId}
        id={projectId}
        onBack={() => navigate(`/landing/projects${listSearch}`)}
        onOpen={open}
        // 当前 Tab 写进 URL：刷新、分享链接与浏览器返回都回到同一工作区；replace 不堆历史。
        tab={parseProjectTab(searchParams.get('tab'))}
        onTabChange={(next) =>
          setSearchParams(
            (current) => {
              const params = new URLSearchParams(current);
              params.set('tab', next);
              return params;
            },
            // setSearchParams 不带 state 会清空 history state，切 Tab 后返回就丢了列表条件。
            { replace: true, state: location.state },
          )
        }
      />
    );
  return (
    <div className="page page-enter landing-management">
      <div className="page-header">
        <div>
          <h1 className="page-title">{settings ? '投放设置' : '项目管理'}</h1>
          <div className="page-sub">
            {settings
              ? '投放产品、HTML 模板与默认文案'
              : '按书籍语言版组织投放：处理章节、配置模板、上传素材并生成 HTML'}{' '}
            <span className="chip chip-info">全局模块 · 不按 App 切</span>
          </div>
        </div>
      </div>
      {settings ? (
        <div className="vstack" style={{ gap: 14 }}>
          <PageTabs
            label="投放设置"
            value={baseTab}
            onChange={setBaseTab}
            items={[
              { id: 'products', label: '投放产品' },
              { id: 'templates', label: 'HTML 模板与默认文案' },
            ]}
          />
          {baseTab === 'products' ? <LandingProductsPage embedded /> : <LandingTemplatesPanel />}
        </div>
      ) : (
        <LandingProjectsPanel onOpen={open} />
      )}
    </div>
  );
}
